export default "__VITE_ASSET__CY4yvqfj__"